import { html } from 'htm/preact';
import { render } from 'preact';
import { useContext, useEffect, useReducer, useState } from 'preact/hooks';
import { Router, route } from 'preact-router';

import { createContext } from 'preact';
import { Model, RootReducer, Product, CartItem, Action, search, parseEmbeddedProducts } from './model';

import translations from 'bundle-text:./translations.csv';
import { CSV } from './csv';

// components

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import ProductCart from './components/ProductCart';
import ProductDetail from './components/ProductDetails';
import CartView from './components/CartView';
import QuotesView from './components/QuotesView';

import './assets/css/filter.css';

const translationsCsv: any[] = CSV.csvToObject(translations);

const langMap: { [key: string]: { [key: string]: string } } = translationsCsv.reduce((p, n) => {
    p[n['en']] = n;
    return p;
}, {});

console.log("LANG_MAP", langMap);

export const DEFAULT_STATE = new Model();

console.log("DEFAULT_STATE", DEFAULT_STATE);


let params = (new URL(window.location.href)).searchParams;
let lang = params.get("lang") || localStorage.getItem('lang') || 'en';

localStorage.setItem('lang', lang);

export function translate(key: string) {
    return (langMap[key] ? langMap[key][lang] || key : key).trim();
}

const StoreContext = createContext({
    state: DEFAULT_STATE,      // Your default state.
    dispatch: (action: Action) => { },       // Stubbed. Will be replaced.
});


export const ctx = () => useContext(StoreContext)

export interface CartResponse {
    message: string;
    url: string;
    data: { [key: string]: string },
    data_array: { key: string, value: string }[]
}

export async function punchoutCart(data: { items: CartItem[], currency: string }): Promise<CartResponse> {


    const res = await (await fetch('https://punchout.cloud/cart/' + localStorage.getItem('punchout_id'), {
        body: JSON.stringify({ cart: { Catalog: data }, custom: {} }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },

    })).text();

    try {
        return JSON.parse(res);
    } catch (e) {
        throw new Error(res);
    }
}

class Punchout {

    _block: any;

    async submitCart(cart: { items: CartItem[], currency: string }) {
        try {
            this.showBlock();
            const res = await punchoutCart(cart);
            if (!res.url || !res.data) {
                alert(res.message || 'An error happened with punchout');
                this.hideBlock();
                return;
            }
            const form = this.createPunchoutForm(res);
            localStorage.clear();

            form.submit();
            form.onerror = () => this.hideBlock();
            form.onsubmit = () => localStorage.removeItem('punchoutSessionId');
        } catch (error) {
            console.log("ERROR", error);
            alert((error as any).message);
            this.hideBlock();
        }
    }


    createPunchoutForm({ data_array, data, url }: { url: string, data: any, data_array: { key: string, value: string }[] }) {
        const form = document.createElement('form');
        form.setAttribute('hidden', 'true');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', url);
        if (data_array.length) {
            data_array.forEach(({ key, value }) => {
                const input1 = document.createElement('input');
                input1.setAttribute('type', 'text');
                input1.setAttribute('name', key);
                input1.setAttribute('value', value);
                form.appendChild(input1);
            });
        } else {
            for (const key in data) {
                const input = document.createElement('input');
                input.setAttribute('type', 'text');
                input.setAttribute('name', key);
                input.setAttribute('value', data[key]);
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        return form;
    }


    showBlock() {
        this._block = this._block || this.createBlock();
        document.body.appendChild(this._block);
    }

    hideBlock() {
        this._block = this._block || this.createBlock();
        document.body.removeChild(this._block);
    }

    createBlock() {
        const block = document.createElement('div');
        block.classList.add('punchout-block');
        const loading = document.createElement('div');
        loading.classList.add('punchout-loading');
        loading.appendChild(document.createElement('div'));
        loading.appendChild(document.createElement('div'));
        block.appendChild(loading);
        return block;
    }

}


export const punchout = new Punchout();




const punchoutId = window.location.search
    .substring(1)
    .split('&')
    .map(pair => pair.split('='))
    .reduce(
        (p, n) => {
            p[n[0]] = decodeURIComponent(n[1]);
            return p;
        },
        {} as any,
    ).punchout || localStorage.getItem('punchout_id');

if (punchoutId) {
    localStorage.setItem('punchout_id', punchoutId);
}


function App() {

    const [state, dispatch] = useReducer(RootReducer, DEFAULT_STATE);
    const store = { state, dispatch };

    return html`<${StoreContext.Provider} value=${store}>
    <${Header}></${Header}>

    <${Router}>
        <${LoggedView} default />
        <${Login} path="/login/:punchout_id" />
    </${Router}>
</${StoreContext.Provider}>`;

}

function addCustomerJavascript() {
    if ((window as any).customerJavascriptAdded) return;
    const javascript = localStorage.getItem('javascript-' + localStorage.getItem('punchout_id'));
    if (javascript) {
        // add the javascript to the page
        const script = document.createElement('script');
        script.innerHTML = javascript;
        document.head.appendChild(script);
        (window as any).customerJavascriptAdded = true;
    }
}

addCustomerJavascript();

function LoggedView() {

    const { state, dispatch } = ctx();

    useEffect(() => {

        if (localStorage.getItem('catalogs')) {
            fetch('https://punchout.cloud/api/v1/files/K2AMu81fZTRJFFxCWEKHPY?catalog_id=' + localStorage.getItem('catalogs') + '&punchout_id=' + localStorage.getItem('punchout_id'), {
                mode: 'cors',
                cache: 'no-cache',
            })
                .then(response => response.json())
                .then(data => {
                    if (data.javascript) {
                        localStorage.setItem('javascript-' + localStorage.getItem('punchout_id'), data.javascript);
                        addCustomerJavascript();
                    }

                    // this line is used for safari which doesn't ignore \uFEFF\n<?xml version="1.0" encoding="UTF-8"?> or \n <?xml version="1.0" encoding="UTF-8"?> on the response
                    const cleanedXml = data.data[0].data
                    .trim()
                    .replace(/^\uFEFF/, "");
                    
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(cleanedXml, "application/xml");
                    
                    doc.querySelectorAll('product');
                    const products: Product[] = Array.from(doc.querySelectorAll('product')).map(product => {
                        return {
                            sku: product.querySelector('sku')?.textContent || '',
                            name: product.querySelector('name')?.textContent || '',
                            description: product.querySelector('description')?.textContent || '',
                            price: parseFloat(product.querySelector('price')?.textContent || '0'),
                            image: product.querySelector('image')?.textContent || '',
                            unit: product.querySelector('unit')?.textContent || '',
                            unspsc: product.querySelector('unspsc')?.textContent || '',
                            category: product.querySelector('category')?.textContent || '',
                            labels: product.querySelector('label')?.textContent.split(";") || [],
                            labels2: product.querySelector('label2')?.textContent.split(";") || [],
                            stockstatus: '',
                            safetysheet: product.querySelector('safetysheet')?.textContent || undefined,
                            datasheets: product.querySelector('datasheet')?.textContent || undefined,
                            brand: '',
                        }
                    });
                    dispatch({ type: 'products', products });
                })
                .catch(err => {
                    console.error(err);
                    dispatch({ type: 'loading.set', loading: false });
                })
        } else {
            dispatch({ type: 'products', products: parseEmbeddedProducts() });
        }



        // fetch('https://eu.punchout.cloud/cchobby-inventory.json?r=' + Math.random(), {
        //     mode: 'cors',
        //     cache: 'no-cache',

        // })
        //     .then(response => response.json())
        //     .then(data => {
        //         dispatch({ type: 'inventory', data });
        //     })
        //     .catch(err => console.error(err))


        /*
            * This is for fetching inventory from a worker in dev, in prod this should be fetched from the same origin as the frontend is served to avoid CORS issues and to be faster. The worker is needed in prod because of CORS issues.
        */

        const API_BASE =
            location.hostname === "localhost"
                ? "https://cchobby.punchout.cloud"   // where /api/inventory works -> this for dev mode
                : "";

        fetch(`${API_BASE}/api/inventory`) // same origin in prod
            .then(r => {
                return r.json();
            })
            .then(data => {
                /* data : {
                    inventory : [
                        {
                            sku: string, 
                            stock: number, 
                            reservedQty : number, 
                            nextDeliveryDate: string , 
                            nextDeliveryQty: string
                        } 
                    ] 
                } */
                const inventory = data.inventory.reduce((p: any, n: any) => {
                    p[n.sku] = n.stock;
                    return p;
                }, {});

                /* inventory: { [sku: string]: number } */
                dispatch({ type: "inventory", data: inventory });

            })
            .catch(err => console.warn("Inventory fetch failed:", err));


        //fetch('/api/v1/products')
        //  .then(res => res.json())
        //     .then(dispatch());
    }, []);

  


    return html`<${Router}>
        <${Main} default />
        <${CartView} path="/cart" />
        <${ProductDetail} path="/p/:sku" />
        <${QuotesView} path="/quotes" />
    </${Router}>`;
}


function Main() {



    const { state } = ctx();
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setShowButton(window.scrollY > window.innerHeight);
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (state.loading) {
        return html`<div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
            <div class="text-center d-flex flex-column align-items-center justify-content-center gap-1">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <span class="fw-bold">${translate('Loading products...')}</span>
            </div>
        </div>`;
    }

    return html`<div class="app-content content ecommerce-application">
        <div class="content-wrapper container-xxl p-0">
            <${Content}></${Content}>
            <${Sidebar}></${Sidebar}>
            ${showButton && html`<a class="btn btn-primary btn-floating btn" id="btn-back-to-top" style="position: fixed; bottom: 30px; right: 20px;" onclick=${() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up">
                    <line x1="12" y1="19" x2="12" y2="5"></line>
                    <polyline points="5 12 12 5 19 12"></polyline>
                </svg>
            </a>`}
        </div>
    </div>`;

}




function Content() {


    const { state, dispatch } = ctx();


    const products = search(state);

    // sort products by stock
    products.sort((a, b) => {

        if (state.search && (a.sku?.toString().trim() == state.search.trim())) {
            return -1;
        }
        if (state.search && (b.sku?.toString().trim() == state.search.trim())) {
            return 1;
        }
        if (!state.inventory) return 0;
        if (!state.inventory[a.sku] || state.inventory[a.sku] <= 0) return 1;
        if (!state.inventory[b.sku] || state.inventory[b.sku] <= 0) return -1;
        return 0;
    });

    //  Build an infinity load
    useEffect(() => {
        const onScroll = () => {
            const OFFSET = 20; // 👈 adjust this

            const reachedNearBottom =
                window.innerHeight + window.scrollY >=
                document.documentElement.scrollHeight - OFFSET;

            if (reachedNearBottom && state.step < products.length) {

                dispatch({
                    type: "step.set",
                    step: Math.min(state.step + 100, products.length),
                });
            }
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [state.step, products.length]);


    console.log('====================================');
    console.log(products, "Products");
    console.log('====================================');

    return html`<div class="content-detached content-right">
    <div class="content-body">
        <!-- E-commerce Content Section Starts -->
        <section id="ecommerce-header">
            <div class="row">
                <div class="col-sm-12">
                    <div class="ecommerce-header-items">
                        <div class="result-toggler">
                            <button class="navbar-toggler shop-sidebar-toggler" type="button" data-bs-toggle="collapse">
                                <span class="navbar-toggler-icon d-block d-lg-none"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-menu">
                                        <line x1="3" y1="12" x2="21" y2="12"></line>
                                        <line x1="3" y1="6" x2="21" y2="6"></line>
                                        <line x1="3" y1="18" x2="21" y2="18"></line>
                                    </svg></span>
                            </button>
                            <div class="search-results">${products.length} ${translate('results found')}</div>
                        </div>
                        <div class="view-options d-flex">
                            <!--
                            <div class="btn-group dropdown-sort">
                                <button type="button" class="btn btn-outline-primary dropdown-toggle me-1 waves-effect"
                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="active-sorting">Featured</span>
                                </button>
                                <div class="dropdown-menu" style="">
                                    <a class="dropdown-item" href="#">Featured</a>
                                    <a class="dropdown-item" href="#">Lowest</a>
                                    <a class="dropdown-item" href="#">Highest</a>
                                </div>
                            </div>
                            <div class="btn-group" role="group">
                                <input type="radio" class="btn-check" name="radio_options" id="radio_option1"
                                    autocomplete="off" checked="" />
                                <label class="btn btn-icon btn-outline-primary view-btn grid-view-btn waves-effect"
                                    for="radio_option1"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-grid font-medium-3">
                                        <rect x="3" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="3" width="7" height="7"></rect>
                                        <rect x="14" y="14" width="7" height="7"></rect>
                                        <rect x="3" y="14" width="7" height="7"></rect>
                                    </svg></label>
                                <input type="radio" class="btn-check" name="radio_options" id="radio_option2"
                                    autocomplete="off" />
                                <label class="btn btn-icon btn-outline-primary view-btn list-view-btn waves-effect"
                                    for="radio_option2"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="feather feather-list font-medium-3">
                                        <line x1="8" y1="6" x2="21" y2="6"></line>
                                        <line x1="8" y1="12" x2="21" y2="12"></line>
                                        <line x1="8" y1="18" x2="21" y2="18"></line>
                                        <line x1="3" y1="6" x2="3.01" y2="6"></line>
                                        <line x1="3" y1="12" x2="3.01" y2="12"></line>
                                        <line x1="3" y1="18" x2="3.01" y2="18"></line>
                                    </svg></label>
                            </div>-->

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- E-commerce Content Section Starts -->

        <!-- background Overlay when sidebar is shown  starts-->
        <div class="body-content-overlay"></div>
        <!-- background Overlay when sidebar is shown  ends-->

        <!-- E-commerce Search Bar Starts -->
        <section id="ecommerce-searchbar" class="ecommerce-searchbar">
            <div class="row mt-1">
                <div class="col-sm-12">
                    <div class="input-group input-group-merge">
                        <input value=${state.search} onkeyup=${ev => dispatch({ type: 'search', value: ev.target.value })} type="text" class="form-control search-product" id="shop-search"
                            placeholder="${translate('Search here')}" aria-label="Search..." aria-describedby="shop-search" />
                        <span class="input-group-text"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="feather feather-search text-muted">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg></span>
                    </div>
                </div>

            </div>
        </section>
        <!-- E-commerce Search Bar Ends -->

        <!-- E-commerce Products Starts -->
        <section id="ecommerce-products" class="grid-view">
            ${products.slice(0, state.step).map(ProductCart)}
        </section>

        ${state.step >= products.length && products.length > 0 && html`
            <section id="ecommerce-end-indicator" class="text-center py-1">
                <div class="alert alert-info" role="alert">
                    ${translate('You have reached the end of the list')}
                </div>
            </section>
        `}
        <!-- E-commerce Products Ends -->

        <!-- E-commerce Pagination Starts
        <section id="ecommerce-pagination">
            <div class="row">
                <div class="col-sm-12">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-center mt-2">
                            <li class="page-item prev-item"><a class="page-link" href="#"></a></li>
                            <li class="page-item active"><a class="page-link" href="#">1</a></li>
                            <li class="page-item"><a class="page-link" href="#">2</a></li>
                            <li class="page-item"><a class="page-link" href="#">3</a></li>
                            <li class="page-item" aria-current="page"><a class="page-link" href="#">4</a></li>
                            <li class="page-item"><a class="page-link" href="#">5</a></li>
                            <li class="page-item"><a class="page-link" href="#">6</a></li>
                            <li class="page-item"><a class="page-link" href="#">7</a></li>
                            <li class="page-item next-item"><a class="page-link" href="#"></a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section> -->
        <!-- E-commerce Pagination Ends -->

    </div>
</div>`;
}








function WhishlistBtn() {
    return html`<a href="#" class="btn btn-light btn-wishlist waves-effect waves-float waves-light">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart">
        <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
        </path>
    </svg>
    <span>Wishlist</span>
</a>`;
}

function Login({ punchout_id }: { punchout_id: string }) {

    const { state, dispatch } = ctx();
    localStorage.setItem('punchout_id', punchout_id);

    // get query params
    const searchParams = new URLSearchParams(window.location.search);
    const catalogs = searchParams.get('catalogs');
    if (catalogs) {
        localStorage.setItem('catalogs', catalogs);
    } else {
        localStorage.removeItem('catalogs');
    }

    dispatch({ type: 'clear_cart' });
    dispatch({ type: 'filter.clear' });

    route('/');
    return html``;
}







function ProductPreview(product: Product, addToCart: any) {
    return html`<div>${product.name} :${product.price?.toFixed(2).replace(".", ",")}

    <button onclick=${ev => addToCart(product, 1)}>${translate('Add to cart')}</button>
</div>`;
}
function Product({ productId }: { productId: string }) {

}





/*
#[derive(Debug, Clone, Serialize, Deserialize)]
pub struct Quote {
    pub id: Id64,
    pub store_id: i32,
    pub customer_id: i32,
    pub tags: Vec<String>,
    pub email: String,
    pub contact_name: Option<String>,
    pub currency: String,
    pub items: Vec<Item>,
    pub shipping_cost: Option<i64>,
    pub tax: Option<i64>,
    pub data: HashMap<String, String>,
    pub shipping: Option<Address>,
    pub status: String,
    pub punchout_id: Option<Id64>,
    pub created_at: NaiveDateTime,
}*/

export interface QuoteItem {
    id: string;
    name: string;
    price: number;
    quantity: number;
    sku: string;
    data: any;
}

export interface Quote {
    id: string;
    store_id: number;
    customer_id: number;
    tags: string[];
    email: string;
    contact_name?: string;
    currency: string;
    items: QuoteItem[];
    shipping_cost?: number;
    tax?: number;
    data: { [key: string]: string };
    shipping?: Address;
    status: string;
    punchout_id?: number;
    created_at: string;
}

export interface PatchQuote {
    tags?: string[];
    email?: string;
    contact_name?: string;
    currency?: string;
    items?: QuoteItem[];
    shipping_cost?: number;
    tax?: number;
    data?: any;
    shipping?: Address;
}



export interface Address {

}

render(html`<${App} />`, document.body)
